import { employeeMiniProfile } from 'interfaces/EmployeeMiniProfile';
import { z } from 'zod';

export const OneOnOneActionItem = z.object({
  taskId: z.number(),
  instanceDataId: z.number(),
  text: z.string().nullable(),
  // type: z.literal('ONE_ON_ONE'),
  // uuid: z.string(),
  toIds: z.array(employeeMiniProfile),
  from: employeeMiniProfile,
  dueDate: z.string().nullable(),
  detailedStatus: z.enum(['DELAYED', 'ONGOING', 'COMPLETED', 'UNPLANNED', 'COMPLETED_ON_TIME']).nullable(),
  status: z.enum(['ACTIVE', 'COMPLETED']).nullable(),
  // BE to give mini-task schema
});
